import { collection, getDocs, query, where } from "firebase/firestore";

import { db } from "../../../firebase";

const GetAllIncomes = async () => {
  try {
    const ExpenseCollection = collection(db, "Incomes");

    let schoolId = localStorage.getItem("schoolId");
    schoolId = JSON.parse(schoolId);

    const q = query(
      ExpenseCollection,
      where("schoolId", "==", schoolId),
      where("IsDeleted", "==", false)
    );

    const querySnapshot = await getDocs(q);

    let AllExpenses = [];
    querySnapshot.forEach((doc) => {
      AllExpenses.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return AllExpenses;
  } catch (error) {
    console.log("Error Getting Expense Data:", error);
    return;
  }
};

export default GetAllIncomes;
